import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ActiveStorageAttachment from "./ActiveStorageAttachment";
import type Organisation from "./Organisation";
import type OrganisationSocialIntegration from "./OrganisationSocialIntegration";
import type User from "./User";

export enum Status {
  "completed" = "completed",
  "failed" = "failed",
  "processing" = "processing",
  "staged" = "staged",
}

@Model()
class InstagramHandleImport extends ApplicationRecord {
  static jsonapiType = "instagram_handle_imports";

  @HasMany() activeStorageAttachments: ActiveStorageAttachment[];

  @HasMany({ persist: false }) importFiles: ActiveStorageAttachment[];

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @BelongsTo() organisationSocialIntegration: OrganisationSocialIntegration;

  @Attr() organisationSocialIntegrationId: number;

  @Attr() status: Status;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default InstagramHandleImport;
